export default {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  API_VERSION: process.env.REACT_APP_API_VERSION,
  API_SURVEY_ENDPOINT: process.env.REACT_APP_API_SURVEY_ENDPOINT,
  API_SURVEY_VERSION: process.env.REACT_APP_API_SURVEY_VERSION,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  HUBSPOT: process.env.REACT_APP_HUBSPOT,
  LANDINGPAGE_URL:
    process.env.REACT_APP_LANDINGPAGE_URL || 'https://deeptrue.com',
  APP_SURVEY_URL: process.env.REACT_APP_URL_SURVEY,
  IS_PRODUCTION: process.env.REACT_APP_BUILD === 'Production',
  IS_STAGING: process.env.REACT_APP_BUILD === 'Staging',
  IS_DEV: process.env.REACT_APP_BUILD === 'Development',
  IS_NODE_ENV_PRODUCTION: process.env.NODE_ENV === 'production',
  ENVIRONMENT: process.env.REACT_APP_BUILD || 'Development',
  BUILD_VERSION: process.env.REACT_APP_BUILD_VERSION,
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID,
  GA_DOMAINS: ['deeptrue.com'],
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
};
